import React, { useContext } from "react";
import "./Impressum.css";
import { LanguageContext } from "../context/LanguageContext";

export default function Impressum() {
  const { texts } = useContext(LanguageContext);

  return (
    <div className="impressum-container">
      <h1 className="impressum-title">{texts.impressum.title}</h1>

      <p className="impressum-block">
        <strong>{texts.impressum.company}</strong><br />
        {texts.impressum.addressLine1}<br />
        {texts.impressum.addressLine2}<br />
        {texts.impressum.country}
      </p>

      <p className="impressum-block">
        {texts.impressum.registryNumber}<br />
        {texts.impressum.registryCourt}
      </p>

      <p className="impressum-block">
        {texts.impressum.emailLabel}:{" "}
        <a href="mailto:vermieter@glampingoase.ch">
          vermieter@glampingoase.ch
        </a>
      </p>
    </div>
  );
}
